import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from './cn';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  function Label({ className, ...rest }, ref) {
    return (
      <label
        ref={ref}
        className={cn('text-sm font-medium leading-none text-slate-700', className)}
        {...rest}
      />
    );
  },
);
